import { Injectable } from '@angular/core';
import { BullhornEntityTypes, BullhornNamespace } from 'datasource-service-lib';
import { IDataSourceApiService, IEntity } from 'interfaces-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IRecipientInfoService } from './irecipient-info.service';

// TODO: consider if we can use the IEntityProfileService instead?

@Injectable({
  providedIn: 'root',
})
export class BullhornRecipientInfoService implements IRecipientInfoService {
  private readonly dataSourceApiService: IDataSourceApiService;
  private readonly entityTypes: BullhornEntityTypes[] = [
    BullhornEntityTypes.Candidate,
    BullhornEntityTypes.CorporateUser,
    BullhornEntityTypes.ClientContact
  ];

  constructor(
    serviceProviderService: SharedServiceProviderServiceFactory
  ) {
    this.dataSourceApiService = serviceProviderService.getServiceProviderService(BullhornNamespace.name).getDataSourceApiService();
  }

  getEntityTypes(): BullhornEntityTypes[] {
    return this.entityTypes;
  }

  getEntityInfo(entity: IEntity): Observable<any> {
    return this.dataSourceApiService.get(entity, { fields: 'name, email, occupation' }).pipe(
      map((data) => {
        return {
          name: data.name,
          email: data.email,
          role: data.occupation,
        };
      })
    );
  }
}
